import { CallCardLabels } from './PatientAccessCallTimelineItem';

/** The card title. Middot, matching the `PN ·` / `PT ·` convention across Orbit. */
export const PN_CONSULTATION_CARD_TITLE = 'PN · Consultation';

export const PN_CONSULTATION_LABELS: CallCardLabels = {
  start: 'Start consultation notes',
  show: 'Show consultation notes',
  hide: 'Hide consultation notes',
};
